import React from "react";
import { Link } from "react-router-dom";
import { FaProjectDiagram, FaUsers, FaTruck } from "react-icons/fa";
import AnimatedCountUp from "../components/AnimatedCountUp";
import "./SignGraphicsBanner.css";

const SignGraphicsBanner = () => {
  return (
    <section className="sg-home-banner">
      <div className="sg-home-content">
        <span>Creative Branding Solutions</span>
        <h2>Sign & Graphics</h2>
        <p>
          Custom signage, corporate gifts, awards, packaging, printing and
          promotional branding solutions for modern businesses.
        </p>

        <div className="sg-home-stats">
          <div className="sg-stat-card">
            <div className="sg-stat-icon">
              <FaProjectDiagram />
            </div>
            <h3>
              <AnimatedCountUp end={1000} duration={4} separator="," suffix="+" />
            </h3>
            <p>Projects Completed</p>
          </div>

          <div className="sg-stat-card">
            <div className="sg-stat-icon">
              <FaUsers />
            </div>
            <h3>
              <AnimatedCountUp end={500} duration={4} suffix="+" />
            </h3>
            <p>Corporate Clients</p>
          </div>

          <div className="sg-stat-card">
            <div className="sg-stat-icon">
              <FaTruck />
            </div>
            <h3>UAE</h3>
            <p>Wide Delivery</p>
          </div>
        </div>

        <div className="sg-home-buttons">
          <Link to="/sign-graphics" className="sg-home-btn explore-btn">
            Explore More
          </Link>
          <Link to="/quote" className="sg-home-btn quote-btn">
            Request a Quote
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SignGraphicsBanner;
